import type { RouteRecordRaw } from 'vue-router';

export const usersRoute: RouteRecordRaw = {
  path: '/users',
  name: 'Users',
  component: () => import('./pages/UsersPage.vue'),
  meta: {
    title: 'Users',
    layout: 'main',
    // The Users page is an admin surface (create/update/delete/roles). Every
    // authenticated user now has `users:list` for the assignee picker, so gate
    // the admin page on an admin-only action instead.
    authorize: ({ isGranted }) => isGranted('tm:core:users:create'),
  },
};

export const userDetailRoute: RouteRecordRaw = {
  path: '/users/:id',
  name: 'UserDetail',
  component: () => import('./pages/UserPage.vue'),
  meta: {
    title: 'User',
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('tm:core:users:get'),
  },
};
